function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 11.8114L11.5371 1.05979L14.9402 4.46293L4.18862 15.25H0.75V11.8114Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.92413 3.57936L12.4207 7.07588",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgEdit = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Edit.6caee9d9.svg";
export { ForwardRef as ReactComponent };